import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import apiClient from "../../utils/apiClient";
import { pendingStockOperation, retryPendingStockOperation, STOCK_POSTING_JOURNAL_EVENT } from "../../utils/idempotentStockPosting";
import "./PendingStockOperationNotice.css";

export default function PendingStockOperationNotice({ scope, onResolved }) {
  const { t } = useTranslation(["stock", "common"]);
  const [pending,setPending]=useState(()=>pendingStockOperation(scope));
  const [busy,setBusy]=useState(false),[message,setMessage]=useState("");
  useEffect(()=>{
    const update=()=>setPending(pendingStockOperation(scope)); update();
    window.addEventListener(STOCK_POSTING_JOURNAL_EVENT,update);
    return()=>window.removeEventListener(STOCK_POSTING_JOURNAL_EVENT,update);
  },[scope]);
  async function recover(){
    setBusy(true);setMessage("");
    let response;
    try {response=await retryPendingStockOperation(apiClient,scope);}
    catch(err){setMessage(t(`stock:postingSafety.codes.${err?.response?.data?.code || err.code}`,{defaultValue:err?.response?.data?.message||err.message}));setBusy(false);return;}
    setMessage(t("stock:postingSafety.recovered",{id:response?.data?.movement?.id||response?.data?.stock_movement_id||response?.data?.id||"—"}));
    // A UI refresh failure is not a failed posting and must not cause a new key.
    try{await onResolved?.(response.data);}catch(_){setMessage(t("stock:postingSafety.refreshFailed"));}
    setBusy(false);
  }
  if(!pending&&!message)return null;
  return <section className="stock-posting-recovery" role="status" aria-live="polite">
    {pending&&<><strong>{t("stock:postingSafety.pendingTitle")}</strong><p>{t("stock:postingSafety.pendingHint")}</p>
      {pending.error?<p>{pending.error}</p>:<><small>{pending.url} · {pending.createdAt} · {pending.key}</small>
        <button type="button" className="stock-btn stock-btn--secondary" onClick={recover} disabled={busy}>{t(busy?"common:common.loading":"stock:postingSafety.retrySame")}</button></>}
    </>}
    {message&&<p>{message}</p>}
  </section>;
}
